
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2 } from "lucide-react";
import { ArrowLeft } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useFreeResponseContext } from "./FreeResponseContext";

interface FreeResponseFormProps {
  questions: any[];
  onBack?: () => void;
}

export function FreeResponseForm({ questions, onBack }: FreeResponseFormProps) {
  const { 
    responses, 
    isSubmitting, 
    isCompleted, 
    isAdmin, 
    handleResponseChange, 
    handleSubmit 
  } = useFreeResponseContext();

  return (
    <ScrollArea className="h-[calc(100vh-100px)]">
      <div className="p-6">
        {onBack && (
          <Button variant="ghost" size="sm" className="mb-4" onClick={onBack}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
        )}
        
        <div>
          <h3 className="text-xl font-semibold text-[#1A1F2C]">Free Response Assessment</h3>
          <p className="mt-2 text-[#8E9196]">Please answer all questions thoughtfully.</p>
        </div>
        
        <div className="space-y-6 mt-6">
          <h4 className="text-md font-semibold text-[#1A1F2C]">Questions:</h4>
          {questions.map((question, index) => (
            <div key={question.id} className="border border-[#E5DEFF] rounded-xl p-6 space-y-4">
              <p className="font-medium text-[#1A1F2C]">{index + 1}. {question.question}</p>
              
              <Textarea
                value={responses[question.id] || ''}
                onChange={(e) => handleResponseChange(question.id, e.target.value)}
                placeholder={isAdmin ? "This field is disabled in admin preview mode" : "Enter your response here..."}
                className="min-h-[100px]"
                disabled={isCompleted || isSubmitting || isAdmin}
              />
            </div>
          ))}
        </div>
        
        <div className="pt-4 border-t border-[#E5DEFF] mt-6">
          {!isAdmin ? (
            <Button
              onClick={handleSubmit}
              disabled={isCompleted || isSubmitting || isAdmin}
              className="w-full bg-[#8B5CF6] hover:bg-[#7C3AED]"
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Submitting...
                </>
              ) : isCompleted ? (
                "Already Submitted"
              ) : (
                "Submit Responses"
              )}
            </Button>
          ) : (
            <div className="w-full text-center py-2 px-4 bg-gray-100 rounded-md">
              <span className="text-sm text-gray-500">Admin preview mode - submission disabled</span>
            </div>
          )}
        </div>
      </div>
    </ScrollArea>
  );
}
